import {
    GET_EXPENSE_ACCOUNTS_VALIDATION,
    GET_EXPENSE_ACCOUNTS_VALIDATION_ERROR,
    GET_EXPENSE_ACCOUNTS_VALIDATION_SUCCESS,
    IExpenseAccountValidationFilters,
    IExpenseAccountValidationRow,
    SET_EXPENSE_ACCOUNTS_VALIDATION_FILTERS,
} from '@components/expenseAccountValidation/redux/types/ExpenseAccountValidationTypes';

interface IState {
    expenseAccounts: IExpenseAccountValidationRow[];
    filters: IExpenseAccountValidationFilters;
    loading: boolean;
    error: boolean;
    page: number;
    limit: number;
    count: number;
    totalPages: number;
}

const initialState: IState = {
    expenseAccounts: [],
    filters: {},
    loading: false,
    error: false,
    page: 1,
    limit: 10,
    count: 0,
    totalPages: 0,
};

/** Estado del módulo interno de Validación de Cuenta de Gastos (HU 2). */
const expenseAccountValidation = (state = initialState, action: any): IState => {
    switch (action.type) {
        case GET_EXPENSE_ACCOUNTS_VALIDATION:
            return {...state, loading: true, error: false};
        case GET_EXPENSE_ACCOUNTS_VALIDATION_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                expenseAccounts: action.value?.data ?? [],
                // El `TransformInterceptor` del backend responde
                // `{data, metadata, statusCode}`; la paginación viaja en `metadata`.
                page: action.value?.metadata?.currentPage ?? state.page,
                limit: action.value?.metadata?.limit ?? state.limit,
                count: action.value?.metadata?.count ?? 0,
                totalPages: action.value?.metadata?.totalPages ?? 0,
            };
        case GET_EXPENSE_ACCOUNTS_VALIDATION_ERROR:
            // La lista se vacía a propósito: dejar los renglones anteriores tras un fallo
            // haría creer que son el resultado del filtro que se acaba de aplicar.
            return {...state, loading: false, error: action.value, expenseAccounts: []};
        case SET_EXPENSE_ACCOUNTS_VALIDATION_FILTERS:
            return {...state, filters: action.value};
        default:
            return state;
    }
};

export default expenseAccountValidation;
